"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPoleForemanFieldIds = void 0;
exports.LegacyPoleForemanFieldIds = {
    TRANSMISSION_POLE: 'transmissionPole',
    ANCHOR_GUY_STRUT_HEIGHT: 'guyStrutHeight',
    FRAMING_TYPE: 'framingType',
    RULING_SPAN: 'rulingSpan',
    PHASE_A_HEIGHT: 'phaseAHeight',
    PHASE_B_HEIGHT: 'phaseBHeight',
    PHASE_C_HEIGHT: 'phaseCHeight',
};
//# sourceMappingURL=FieldID.js.map